import User from "shared/types/user.model";
import moment from "moment";
import { REQUEST, FAILURE, SUCCESS } from "./util/action-types";
import { ThunkAction } from "redux-thunk";
import { IRootState } from ".";
import { AxiosResponse } from "axios";
import { Action } from "redux";
import {
	listUsers,
	getUser,
	createUser as addUser,
	updateUser
} from "shared/network/user-api";

export const ACTION_TYPES = {
	FETCH_USER_LIST: "user/FETCH_USER_LIST",
	FETCH_USER: "user/FETCH_USER",
	CREATE_USER: "user/CREATE_USER",
	MODIFY_USER: "user/MODIFY_USER",
	RESET: "user/RESET"
};

const initialState = {
	loading: false,
	entities: [] as Array<User>,
	entity: {} as User,
	fetchSuccess: false,
	fetchFailure: false,
	createSuccess: false,
	createFailure: false,
	updateSuccess: false,
	updateFailure: false,
	errorMessage: {} as any
};

export type UserState = Readonly<typeof initialState>;

export default (state = initialState, action: any) => {
	switch (action.type) {
		case REQUEST(ACTION_TYPES.FETCH_USER):
		case REQUEST(ACTION_TYPES.FETCH_USER_LIST):
			return {
				...state,
				loading: true,
				fetchFailure: false,
				fetchSuccess: false,
				errorMessage: null
			};
		case REQUEST(ACTION_TYPES.CREATE_USER):
			return {
				...state,
				loading: true,
				createFailure: false,
				createSuccess: false,
				errorMessage: null
			};
		case REQUEST(ACTION_TYPES.MODIFY_USER):
			return {
				...state,
				loading: true,
				updateSuccess: false,
				updateFailure: false,
				errorMessage: null
			};
		case FAILURE(ACTION_TYPES.FETCH_USER_LIST):
		case FAILURE(ACTION_TYPES.FETCH_USER):
			return {
				...state,
				loading: false,
				fetchFailure: true,
				errorMessage: action.payload
			};
		case FAILURE(ACTION_TYPES.CREATE_USER):
			return {
				...state,
				loading: false,
				createFailure: true,
				errorMessage: action.payload
			};
		case FAILURE(ACTION_TYPES.MODIFY_USER):
			return {
				...state,
				loading: false,
				updateFailure: true,
				errorMessage: action.payload
			};
		case SUCCESS(ACTION_TYPES.CREATE_USER):
			return {
				...state,
				loading: false,
				createSuccess: true,
				fetchSuccess: false,
				updateSuccess: false
			};
		case SUCCESS(ACTION_TYPES.MODIFY_USER):
			return {
				...state,
				loading: false,
				updateSuccess: true,
				fetchSuccess: false,
				createSuccess: false
			};
		case SUCCESS(ACTION_TYPES.FETCH_USER_LIST):
			const { users = [] } = action.payload?.data;
			return {
				...state,
				loading: false,
				entities: users.map((user: User) => ({
					...user,
					registrationDate: moment(user.registrationDate).format("LLL")
				}))
			};
		case SUCCESS(ACTION_TYPES.FETCH_USER):
			const { user = {} } = action.payload?.data;
			return {
				...state,
				loading: false,
				entity: user
			};
		case ACTION_TYPES.RESET:
			return {
				...initialState
			};
		default:
			return state;
	}
};

export const getEntities = (): ThunkAction<
	void,
	IRootState,
	AxiosResponse,
	Action<string>
> => async dispatch => {
	await dispatch({
		type: ACTION_TYPES.FETCH_USER_LIST,
		payload: listUsers()
	});
};

export const getEntity = (
	id: number
): ThunkAction<
	void,
	IRootState,
	AxiosResponse,
	Action<string>
> => async dispatch => {
	await dispatch({
		type: ACTION_TYPES.FETCH_USER,
		payload: getUser(id)
	});
};

export const createUser = (
	user: User
): ThunkAction<
	void,
	IRootState,
	AxiosResponse,
	Action<string>
> => async dispatch => {
	await dispatch({
		type: ACTION_TYPES.CREATE_USER,
		payload: addUser(user)
	});
};

export const modifyUser = (
	user: User
): ThunkAction<
	void,
	IRootState,
	AxiosResponse,
	Action<string>
> => async dispatch => {
	await dispatch({
		type: ACTION_TYPES.MODIFY_USER,
		payload: updateUser(user)
	});
};

export const resetUserState = (): ThunkAction<
	void,
	IRootState,
	AxiosResponse,
	Action<string>
> => async dispatch => {
	await dispatch({
		type: ACTION_TYPES.RESET
	});
};
